/* ----------------------------------------------------------------------------
   LBM STOCK BADGE
   商品ページでバリエーションが切り替わったとき、バッジを差し替える。
   Prestige は変更時に form 上で variant:change（bubbles: true）を発火する。
   ------------------------------------------------------------------------- */

(function () {
  'use strict';

  function readLevels(host) {
    var tag = host.querySelector('script[data-lbm-levels]');
    if (!tag) return {};
    try {
      return JSON.parse(tag.textContent);
    } catch (error) {
      return {};
    }
  }

  function update(host, variantId) {
    var slot = host.querySelector('[data-lbm-slot]');
    if (!slot) return;

    var level = variantId ? readLevels(host)[String(variantId)] : '';

    slot.classList.remove('lbm-badge--low', 'lbm-badge--last');

    if (level === 'last' || level === 'low') {
      slot.classList.add('lbm-badge--' + level);
      slot.textContent = level === 'last' ? host.dataset.lastText : host.dataset.lowText;
      slot.hidden = false;
    } else {
      slot.textContent = '';
      slot.hidden = true;
    }
  }

  document.addEventListener('variant:change', function (event) {
    var detail = event.detail || {};
    var variantId = detail.variant ? detail.variant.id : null;

    // イベントは商品フォームから bubble してくる。
    // クイックビューなど1ページに複数の商品が存在しうるので、
    // そのフォームが属する .product-info の中のバッジだけを更新する。
    var form = event.target;
    var scope = (form && form.closest) ? form.closest('.product-info') : null;

    (scope || document).querySelectorAll('lbm-stock-badge').forEach(function (host) {
      update(host, variantId);
    });
  });
})();